<template>
  <div class="office-detail-list" v-iscroll>
    <ul class="office-list-warp">
      <li class="list" :class="{active: item.finish}" v-for="(item, index) in offDetailList">
        <a href="javascript:;">
          <div class="time-name">
            <span class="inner-time">{{item.time}}</span>
            <span class="inner-thing">公证事项：{{item.matter}}</span>
            <span class="inner-name">当事人：{{item.name}}</span>
          </div>
          <div class="git-in">
            <span class="git-in-text">
              {{item.code}}
            </span>
            <span class="git-in-icon">
              <i class="iconfont icon-photograph"></i>
              实时监控
            </span>
            <i class="iconfont icon-finish"></i>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import VIscroll from 'viscroll'
  export default {
    components: { VIscroll },
    props: [
      'offDetailList'
    ],
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters([
      ])
    },
    watch: {
    },
    methods: {
      ...mapActions([
      ]),
      hoverCityOver () {
      },
      hoverCityOut (iner) {
      },
      aab () {
      }
    },
    created () {
      setTimeout(() => {
      }, 1000)
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .office-detail-list {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .office-list-warp {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
    list-style: noen;
    .list {
      width: 100%;
      height: auto;
      a {
        display: block;
        position: relative;
        width: 100%;
        height: 100px;
      }
      &.active .time-name {
        background: $brand-green;
      }
      &.active .icon-finish {
        display: none;
      }
      &.active .git-in-icon {
        display: block;
      }
    }
    .time-name, .git-in {
        width: 100%;
        height: 50%;
        padding-left: 15px;
        padding-right: 15px;
        text-align: left;
        line-height: 50px;
        color: $white;
        font-size: 16px;
      }
      .time-name {
        display: flex;
        justify-content: space-between;
        background: rgba($gray-dark, .8);
        span {
          max-width: 20%;
          display: inline-block;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        .inner-thing, .inner-name {
          max-width: 40%;
        }
      }
    .git-in {
      position: relative;
      background: rgba($gray-dark, .3);
      @include clearfix;
      .git-in-text {
        max-width: 70%;
        display: inline-block;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        float: left;
      }
      .git-in-icon {
        position: relative;
        max-width: 30%;
        height: 30px;
        margin-top: 10px;
        padding-right: 25px;
        padding-left: 5px;
        line-height: 30px;
        border-radius: 4px;
        border: 1px solid $brand-green;
        background: rgba($brand-green, .3);
        text-align: center;
        color: $white;
        display: inline-block;
        float: right;
        display: none;
        .iconfont {
          color: $white;
        }
      }
      i {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 5px;
        margin: auto;
        font-size: 15px;
        color: $brand-green;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// office-detail-list.vue?377dccc2